import API from "../../Api";
import { encryptJson} from "../../utils/react-ec-utils";
import {
  SignUpForm,
  SignUpData,
  SignInForm,
  OTPVerificationDetails,
  MobileVerificationDetails,
  ResetPassword,
} from "./AuthModels";

// SignUp
export function signUp(userDetails: SignUpData) {
  return API({
    method: "post",
    url: "/api/customers/sendSMS",
    headers: {
      Authorization: "",
    },
    data: userDetails,
  });
}

// SignIn
export function signIn(userDetails: SignInForm) {
  const data = encryptJson(userDetails);
  return API({
    method: "post",
    url: "/api/customers/login/v2",
    data: {"data":data},
  });
}

// Mobile
export function verifyMobile(details: MobileVerificationDetails) {
  const data = encryptJson(details);
  return API({
    method: "post",
    url: "/api/customers/sendSMS",
    params:{data}
  });
}


export function signInGuestApi(details: MobileVerificationDetails) {
  const data = encryptJson(details);
  return API({
    method: "post",
    url: "/guest/user",
    data:details
  });
}

// OTP
export function verifyOTP(details: OTPVerificationDetails) {
  const data = encryptJson(details);
  return API({
    method: "post",
    url: "/api/customers/validateOTP/v2",
    data: {"data":data},
  });
}

// Reset Password
export function resetPassword(details: ResetPassword) {
  const data = encryptJson(details);
  return API({
    method: "post",
    url: "/api/customers/resetPassword",
    params:{data}
  });
}



// Get Country Code

export function getCountryCode() {
  return API({
    method: "get",
    url: "/api/customers/getCountry",
  });
}

export function getOtp(data: string){
  return API({
    method: 'post',
    url: '/api/customers/auth/request-otp',
    data: data,
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export function verifyOtp(verifyOtpPayload: any){
  const encryptedData = encryptJson(verifyOtpPayload);
  return API({
    method: 'post',
    url: `/api/customers/auth/verify-otp`,
    data: { data : encryptedData },
  })
}


export function updateProfile(details: ResetPassword) {
  const data = encryptJson(details);
  return API({
    method: "post",
    url: "/api/customers/user/fetch",
    params:details,
     headers: {
      'Content-Type': 'application/json',
    },
  });
}

export function logPrint(data: string) {
  return API({
    method: 'post',
    url: '/print/log-info',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}